import Cookies from 'js-cookie'
import { getRootDomain } from '@/utils/index'

const rootDomain = getRootDomain()

const environment = process.env.VUE_APP_ENV

let TokenKey = 'token'
if (environment === 'development') {
  TokenKey = 'token_dev'
} else if (environment === 'beta') {
  TokenKey = 'token_beta'
} else if (environment === 'production') {
  TokenKey = 'token'
}

export function getToken() {
  if (process.env.NODE_ENV === 'development') {
    return Cookies.get(TokenKey)
  } else {
    return Cookies.get(TokenKey)
  }
}

export function setToken(token) {
  if (process.env.NODE_ENV === 'development') {
    return Cookies.set(TokenKey, token)
  } else {
    return Cookies.set(TokenKey, token, { domain: rootDomain, secure: true, sameSite: 'lax' })
  }
}

export function removeToken() {
  if (process.env.NODE_ENV === 'development') {
    return Cookies.remove(TokenKey)
  } else {
    return Cookies.remove(TokenKey, { domain: rootDomain })
  }
}
